import { writable } from "svelte/store";

const initialState = {
  trophiesDetails: {},
  level: -1,
  isShareOverlayVisible: false,
  creatorSelectedTrophies: null,
  creatorId: null,
};
const { subscribe, update, set } = writable(initialState);

/**
 *
 * @param {Object} obj
 * @returns
 */
const updateState = (obj) => update((oldState) => ({ ...oldState, ...obj }));

/**
 * set the state
 * @param {Object} obj
 * @returns
 */
const setState = (obj) => set(obj);

export default {
  subscribe,
  updateState,
  setState,
};
